import React from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { getCDNImageUrl } from "@/utils/Common";
import styles from "./OptimizingYourTailSpend.module.scss";

function OptimizingYourTailSpend() {
  const router = useRouter();

  const onClickLearnMore = () => {
    router.push("/tail-spend-management");
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.imageWrapper}>
          <Image
            src={getCDNImageUrl("tail-spend-hero1.webp")}
            alt="Optimizing Your Tail Spend"
            fill
            style={{ objectFit: "cover" }}
          />
        </div>
        <div className={styles.textContent}>
          <div className={styles.headingGroup}>
            <div className={styles.labelGroup}>
              <p className={styles.label}>ELCHEMY EXPERTISE</p>
              <h2 className={styles.heading}>Optimizing Your Tail Spend</h2>
            </div>
            <p className={styles.description}>
              Most companies have a blind spot in their supply chain — hundreds
              of low-value purchases that quietly eat into margins, create
              compliance headaches, and slow operations down. That&apos;s tail
              spend, and it&apos;s more costly than it looks.
              <br />
              <br />
              At Elchemy, we take it off your plate entirely. Our dedicated
              sourcing team consolidates your fragmented purchases, benchmarks
              pricing against global markets, and plugs into our Elixir platform
              to give you full visibility from order to delivery. The result?
              Less noise, lower costs, and a supply chain that actually runs
              smoothly.
            </p>
          </div>
          <button className={styles.ctaButton} onClick={onClickLearnMore}>
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
}

export default OptimizingYourTailSpend;
